import { gql } from '@apollo/client';

export const GET_UPLOAD_PRICE = gql`
  query productPrice($companyId: ID!, $productType: String!) {
    productPrice(companyId: $companyId, productType: $productType) {
      price
    }
  }
`;
